import React from 'react';

const SvgWeLoveTravel = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(11 18)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M39.947 66.885l1.64 1.042 2.046-1.302.402-.26 1.587-1.042 1.551-1.039 1.515-1.037a157.201 157.201 0 005.155-3.723l1.216-.927 1.316-1.03c1.136-.9 2.231-1.797 3.284-2.693l1.04-.896 1.154-1.022.564-.51.554-.51 1.082-1.019c10.463-10.01 15.694-19.793 15.694-29.347C79.747 9.657 70.172 0 58.36 0c-6.464 0-12.257 2.892-16.177 7.463l-.341.407-.254.32-.254-.32C37.414 3.064 31.469 0 24.815 0 13.005 0 3.428 9.657 3.428 21.57c0 9.554 5.232 19.337 15.694 29.347l1.082 1.02c.367.339.74.68 1.119 1.02l1.154 1.021a118.075 118.075 0 004.323 3.59l1.317 1.029a153.6 153.6 0 006.37 4.65l1.515 1.037 1.551 1.04 1.587 1.04.807.521z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M72.188 31.058l2.79-2.107.454-13.32 3.555-2.687c.667-.504 2.1-3.36 1.379-4.393-.723-1.032-3.78-.499-4.447.005l-3.556 2.686L60.037 7.58l-2.791 2.107 9.98 5.438-4.342 3.282-3.448-.814-2.548 1.924 4.796 3.148 1.4 5.714 2.547-1.924.32-3.66 4.344-3.282 1.892 11.547z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.994,
  cy: 8.651,
  r: 1.448,
  fill: "#BDBDBD",
  transform: "rotate(31 20.994 8.651)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.313,
  cy: 15.815,
  r: 1.448,
  fill: "#BDBDBD",
  transform: "rotate(31 21.313 15.815)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.191,
  cy: 12.665,
  r: 1.448,
  fill: "#BDBDBD",
  transform: "rotate(31 14.19 12.665)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M6.546 34.467c-2.707 3.02-3.768 5.602-3.123 7.622.761 2.383 4.649 3.603 10.497 3.152l.757-.066a41.713 41.713 0 003.23-.454l.856-.161.874-.18c.147-.031.294-.064.442-.098 10.924-2.456 23.93-8.83 36.799-18.643a1.04 1.04 0 111.261 1.654C45.042 37.28 31.766 43.787 20.536 46.31l-.453.1-.895.186c-9.463 1.875-16.35.493-17.747-3.875-.985-3.081.566-6.566 4.284-10.43l.82 2.174z"
})));

export default SvgWeLoveTravel;